module.exports = __webpack_public_path__ + "img/a8cd7fc.jpg";